import { api } from '../../lib/api.ts';

export interface OrgInfo {
  id: string;
  name: string;
  contactEmail: string;
  hasStamp: boolean;
}

export const orgSettingsApi = {
  get: () => api.get<{ org: OrgInfo }>('/org').then((r) => r.data.org),
  patch: (patch: { name?: string; contactEmail?: string }) =>
    api.patch<{ org: OrgInfo }>('/org', patch).then((r) => r.data.org),
  uploadStamp: (file: File) => {
    const fd = new FormData();
    fd.append('image', file);
    return api.post<{ hasStamp: boolean }>('/org/stamp', fd).then((r) => r.data);
  },
  removeStamp: () => api.delete('/org/stamp').then(() => undefined),
  // The preview needs the auth header, so fetch the stamp as a blob via the api
  // instance and hand back an object URL. The caller must revoke it.
  fetchStampBlobUrl: () =>
    api.get('/org/stamp/file', { responseType: 'blob' }).then((r) => URL.createObjectURL(r.data as Blob)),
};
